/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmailTemplateWithRelations } from './emailTemplateWithRelations';
import { EmailAttachment } from './emailAttachment';
import { EmailLogWithRelations } from './emailLogWithRelations';


/**
 * (tsType: EmailWithRelations, schemaOptions: { includeRelations: true })
 */
export interface EmailWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: number;
    templateId?: number;
    subject: string;
    htmlTemplate: string;
    status?: EmailWithRelations.StatusEnum;
    totalRecipients?: number;
    sentCount?: number;
    failedCount?: number;
    batchId?: string;
    commonVariables?: object;
    attachments?: Array<EmailAttachment>;
    source?: EmailWithRelations.SourceEnum;
    template?: EmailTemplateWithRelations;
    emailLogs?: Array<EmailLogWithRelations>;
}
export namespace EmailWithRelations {
    export type StatusEnum = 'queued' | 'sending' | 'completed' | 'failed';
    export const StatusEnum = {
        Queued: 'queued' as StatusEnum,
        Sending: 'sending' as StatusEnum,
        Completed: 'completed' as StatusEnum,
        Failed: 'failed' as StatusEnum
    };
    export type SourceEnum = 'manual' | 'system';
    export const SourceEnum = {
        Manual: 'manual' as SourceEnum,
        System: 'system' as SourceEnum
    };
}


